import { apiClient } from 'api'
import { Game, Score } from 'types/games'

export const getGames = () => apiClient.get<Game[]>('/games')

export const getGamesInLeague = (leagueId: number) => apiClient.get<Game[]>(`/games/league/${leagueId}`)

export const getGameById = (gameId: number) => apiClient.get<Game>(`/games/${gameId}`)

export const createGame = (game: Game) => apiClient.post<Game, Game>('/games', game)

export const editGame = (game: Game) => apiClient.patch<Game>(`/games/${game.id}`, game)

export const deleteGame = (id: number) => apiClient.delete(`/games/${id}`)

export const getLeaguesScoreTable = (leagueId: number) => apiClient.get<Score[]>(`/games/score-table/${leagueId}`)
